import { reviews } from "@/mocks/index";

export default function ReviewSection() {
  return (
    <section id="review" className="scroll-mt-20 bg-stone-950 py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <div className="mb-3 flex items-center gap-2">
              <i className="ri-quote-text text-2xl text-orange-500" />
              <span className="text-xs font-semibold uppercase tracking-widest text-orange-400">STREAMER TAKE</span>
            </div>
            <h2 className="text-2xl font-black text-white md:text-4xl">主播锐评 · 一手观点</h2>
          </div>
          <p className="max-w-md text-sm text-stone-500">
            追热点不只看热闹，也看门道。听听常年蹲一线的主播，怎么拆这段戏、怎么解这波反转。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-6 md:grid-cols-2">
          {reviews.map((r) => (
            <figure
              key={r.streamer}
              className="relative flex flex-col justify-between overflow-hidden rounded-3xl border border-white/10 bg-gradient-to-br from-white/[0.06] to-transparent p-6 md:p-8"
            >
              <div className="pointer-events-none absolute -right-6 -top-6 h-24 w-24 rounded-full bg-orange-500/10 blur-2xl" />
              <span className="mb-4 inline-flex w-fit items-center gap-1.5 whitespace-nowrap rounded-full bg-white/5 px-3 py-1 text-xs text-amber-300">
                <i className="ri-mic-line" />
                {r.tag}
              </span>
              <blockquote className="text-base leading-relaxed text-stone-100 md:text-lg">
                “{r.quote}”
              </blockquote>
              <figcaption className="mt-6 flex items-center gap-3">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-gradient-to-br from-orange-500 to-amber-400 font-bold text-stone-950">
                  {r.streamer.slice(0, 1)}
                </span>
                <div>
                  <div className="text-sm font-semibold text-white">{r.streamer}</div>
                  <div className="text-xs text-stone-500">99吃瓜 · 认证主播</div>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}